module.exports = __webpack_public_path__ + "static/media/PaketD.b88624d7.jpeg";